import {start} from "./consts"

export const STATUS_CODES = [
    "start",
    "bronze",
    "silver",
    "gold",
    "platinum",
    "premium",
    "ultima",
    "signature",
    "diamond"
] as const

export type StatusCode = typeof STATUS_CODES[number]

export type StatusLikeCode = StatusCode | ""

export type VisitRequirement =
    | { type: "services_count" }
    | { type: "single_visit_amount"; amount: number }

export const isStatusCode = (value: string): value is StatusCode => {
    return (STATUS_CODES as readonly string[]).includes(value)
}

export const resolveStatusCode = (value: unknown): StatusLikeCode => {
    // Неизвестные значения намеренно сводим к start, чтобы UI не строил пути к несуществующим ассетам.
    if (typeof value !== "string") {
        return start.code
    }

    if (value === "") {
        return start.code
    }

    return isStatusCode(value) ? value : start.code
}

export const getStatusCodeFromModel = (status: { code?: string; name?: string } | null | undefined): StatusLikeCode => {
    if (!status) {
        return start.code
    }

    // Поддерживаем и новую модель с code, и старую модель API/сторов с name.
    const code = typeof status.code === "string" ? status.code : status.name
    return resolveStatusCode(code)
}

export interface PrizeItem {
    id: number
    name: string
}

export type StatusItemParams = {
    id: number
    order: number
    code: StatusCode
    title: string
    cashback_for_visits: number
    discount: number
    prizes: PrizeItem[]
    need_plus: boolean
    need_rank: StatusCode | null
    hype_products_discount: number
}

export class StatusItem {
    id: number
    order: number
    code: StatusCode
    title: string
    cashback_for_visits: number
    discount: number
    prizes: PrizeItem[]
    need_plus: boolean
    need_rank: StatusCode | null
    hype_products_discount: number

    constructor(params: StatusItemParams) {
        this.id = params.id
        this.order = params.order
        this.code = params.code
        this.title = params.title
        this.cashback_for_visits = params.cashback_for_visits
        this.discount = params.discount
        this.prizes = params.prizes
        this.need_plus = params.need_plus
        this.need_rank = params.need_rank
        this.hype_products_discount = params.hype_products_discount
    }
}